import React from 'react';
import { Hits, useHits } from 'react-instantsearch';
import ProductHit from './ProductHit';
const ProductHits = () => {
  const { items } = useHits();

  return (
    <>
      {items?.length > 0 ? (
        <Hits className="products" hitComponent={ProductHit} />
      ) : (
        <p className={'no-results'}>No results</p>
      )}
    </>
  );
};

export default ProductHits;
